
import { IVehicle, Vehicle } from "@/models/vehicle.entity";
import { IReport } from "@/models/report.entity";
import vehicleService from "@/services/mrfiktiv/services/vehicleService";
import { MrfiktivPageViewModelGen, MrfiktivVehicleViewModelGen } from "@/services/mrfiktiv/v1/data-contracts";
import { Component, Vue } from "vue-property-decorator";
import { handleError } from "@/lib/utility/handleError";

@Component({})
export default class PartnerReportVehicleSuggestionMixin extends Vue {
  loadingVehicleSuggestion = false;
  vehicleSuggestions: IVehicle[] = [];

  async lookupVehicleSuggestions(report: IReport) {
    this.loadingVehicleSuggestion = true;

    const found: IVehicle[] = [];
    const promises = [];

    const identificationnumber = report.registrationResults?.identificationnumber;
    const externalId = report.externalId;
    const numberplate = report.numberplate;

    // make sure results are unique
    const addToFound = (
      foundPage: MrfiktivPageViewModelGen & {
        data?: MrfiktivVehicleViewModelGen[] | undefined;
      }
    ) => {
      for (const newFound of foundPage.data ?? []) {
        if (!found.find(foundElement => newFound.id === foundElement.id)) {
          found.push(new Vehicle(newFound));
        }
      }
    };

    if (identificationnumber) {
      promises.push(
        await vehicleService
          .getAll({
            partnerId: report.partnerId,
            filter: [{ key: "identificationnumber", operation: "$eq", value: identificationnumber }]
          })
          .then(addToFound)
          .catch(handleError)
      );
    }
    if (externalId) {
      promises.push(
        await vehicleService
          .getAll({
            partnerId: report.partnerId,
            filter: [{ key: "displayName", operation: "$eq", value: externalId }]
          })
          .then(addToFound)
          .catch(handleError)
      );
    }
    if (numberplate) {
      promises.push(
        await vehicleService
          .getAll({
            partnerId: report.partnerId,
            filter: [{ key: "numberplate", operation: "$eq", value: numberplate }]
          })
          .then(addToFound)
          .catch(handleError)
      );
    }

    await Promise.all(promises);

    this.vehicleSuggestions.splice(0, this.vehicleSuggestions.length, ...found);
    this.loadingVehicleSuggestion = false;
  }
}
